import React, {
  useState,
  useMemo,
  useRef,
  useEffect,
  useCallback,
} from "react";
import "./Users.scss";

import {
  getUsersApi,
  getUserByIdApi,
  createUserApi,
  updateUserStatusApi,
  getRolesApi,
  getDepartmentsApi,
  searchUsersApi,
  updateUserApi,
  resetUserPasswordApi, // ← ADD THIS
  resetUserSessionsApi,
} from "../../../../api/api";

// ─── Constants ────────────────────────────────────────────────────────────────
const STATUSES = ["All Status", "ACTIVE", "DISABLED", "LOCKED"];

const STATUS_LABEL = {
  ACTIVE: "Active",
  DISABLED: "Disabled",
  LOCKED: "Locked",
};
function initials(name = "") {
  return name
    .split(" ")
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
}

const AVATAR_COLORS = [
  "#0062FE",
  "#8B5CF6",
  "#22C55E",
  "#F97316",
  "#EF4444",
  "#06B6D4",
  "#EC4899",
  "#F59E0B",
];
function avatarColor(str = "") {
  let hash = 0;
  for (let i = 0; i < str.length; i++)
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

const PAGE_SIZE_OPTIONS = [10, 20, 50];

// ─── Icons ────────────────────────────────────────────────────────────────────
const Ico = {
  Search: (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  ),
  Plus: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  Upload: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  ),
  Download: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  ),
  Dots: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="5" r="1" />
      <circle cx="12" cy="12" r="1" />
      <circle cx="12" cy="19" r="1" />
    </svg>
  ),
  Eye: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  Edit: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
  ),
  Lock: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  ),
  LogOut: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  ),
  Trash: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    </svg>
  ),
  Close: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Refresh: (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="1 4 1 10 7 10" />
      <path d="M3.51 15a9 9 0 1 0 .49-3.15" />
    </svg>
  ),
  ChevronL: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="15 18 9 12 15 6" />
    </svg>
  ),
  ChevronR: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="9 18 15 12 9 6" />
    </svg>
  ),
  SortUp: (
    <svg
      width="10"
      height="10"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="18 15 12 9 6 15" />
    </svg>
  ),
  User: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Users: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  Shield: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  Activity: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  ),
  XCircle: (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  ),
  Spinner: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    >
      <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    </svg>
  ),
  Mail: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  ),
  Info: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
  ),
};

// ─── Toast ────────────────────────────────────────────────────────────────────
function useToast() {
  const [toasts, setToasts] = useState([]);
  const add = useCallback((msg, type = "info") => {
    const id = Date.now();
    setToasts((p) => [...p, { id, msg, type }]);
    setTimeout(() => setToasts((p) => p.filter((t) => t.id !== id)), 3500);
  }, []);
  return {
    toasts,
    toast: {
      success: (m) => add(m, "success"),
      error: (m) => add(m, "error"),
      info: (m) => add(m, "info"),
    },
  };
}

function ToastStack({ toasts }) {
  if (!toasts.length) return null;
  return (
    <div
      style={{
        position: "fixed",
        top: 20,
        right: 20,
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        gap: 8,
      }}
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          style={{
            background:
              t.type === "success"
                ? "#22C55E"
                : t.type === "error"
                  ? "#EF4444"
                  : "#0062FE",
            color: "#fff",
            padding: "10px 18px",
            borderRadius: 8,
            fontSize: 13,
            fontWeight: 500,
            boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
            minWidth: 220,
          }}
        >
          {t.msg}
        </div>
      ))}
    </div>
  );
}

// ─── Row Dropdown ─────────────────────────────────────────────────────────────
function RowMenu({
  user,
  onView,
  onEdit,
  onToggleStatus,
  onResetPw,
  onResetSessions,
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const isActive = user.status === "ACTIVE";

  return (
    <div className="up-row-actions" ref={ref}>
      <button className="up-menu-btn" onClick={() => setOpen((v) => !v)}>
        {Ico.Dots}
      </button>
      {open && (
        <div className="up-dropdown">
          <button
            className="up-dropdown__item"
            onClick={() => {
              onView(user);
              setOpen(false);
            }}
          >
            {Ico.Eye} View Profile
          </button>
          <button
            className="up-dropdown__item"
            onClick={() => {
              onEdit(user);
              setOpen(false);
            }}
          >
            {Ico.Edit} Edit User
          </button>
          <button
            className="up-dropdown__item"
            onClick={() => {
              onResetPw(user);
              setOpen(false);
            }}
          >
            {Ico.Mail} Resend Setup Email
          </button>
          <button
            className="up-dropdown__item"
            onClick={() => {
              onResetSessions(user);
              setOpen(false);
            }}
          >
            {Ico.LogOut} Reset Sessions
          </button>
          <button
            className={`up-dropdown__item up-dropdown__item--divider${isActive ? " up-dropdown__item--danger" : ""}`}
            onClick={() => {
              onToggleStatus(user);
              setOpen(false);
            }}
          >
            {isActive ? (
              <>{Ico.Trash} Deactivate</>
            ) : (
              <>{Ico.Refresh} Activate</>
            )}
          </button>
        </div>
      )}
    </div>
  );
}

// ─── Add / Edit User Drawer ───────────────────────────────────────────────────
const EMPTY_FORM = {
  fullName: "",
  email: "",
  mobile: "",
  employeeNo: "",
  departmentId: "",
  roleId: "",
};

function UserDrawer({ user, roles, departments, onClose, onSave, saving }) {
  const isEdit = !!user?.id;

  const [form, setForm] = useState(() => {
    if (isEdit) {
      return {
        ...EMPTY_FORM,
        fullName: user.fullName || "",
        email: user.email || "",
        mobile: user.mobile || "",
        employeeNo: user.employeeNo || "",
        departmentId: user.department?.id || user.departmentId || "",
        roleId: user.role?.id || user.roleId || "",
      };
    }
    return { ...EMPTY_FORM };
  });

  const [errors, setErrors] = useState({});

  const set = (k, v) => {
    setForm((p) => ({ ...p, [k]: v }));
    if (errors[k]) setErrors((p) => ({ ...p, [k]: "" }));
  };

  const validate = () => {
    const e = {};
    if (!form.fullName.trim()) e.fullName = "Full name is required";
    if (!form.email.trim()) e.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      e.email = "Invalid email format";
    if (!form.roleId) e.roleId = "Role is required";
    if (!form.departmentId) e.departmentId = "Department is required";
    return e;
  };

  const handleSave = () => {
    const e = validate();
    if (Object.keys(e).length) {
      setErrors(e);
      return;
    }

    const payload = {
      fullName: form.fullName.trim(),
      email: form.email.trim(),
      mobile: form.mobile.trim(),
      employeeNo: form.employeeNo.trim(),
      departmentId: form.departmentId,
      roleId: form.roleId,
    };

    onSave(payload, user?.id);
  };

  return (
    <>
      <div className="up-drawer-overlay" onClick={onClose} />
      <div className="up-drawer">
        <div className="up-drawer__header">
          <div>
            <h3 className="up-drawer__title">
              {isEdit ? "Edit User" : "Add New User"}
            </h3>
            <p className="up-drawer__subtitle">
              {isEdit
                ? `Editing ${user.fullName}`
                : "Fill in details to create a new user. A password setup email will be sent automatically."}
            </p>
          </div>
          <button className="up-drawer__close" onClick={onClose}>
            {Ico.Close}
          </button>
        </div>

        <div className="up-drawer__body">
          {/* Identity */}
          <div className="up-form-section">
            <span className="up-form-section__label">Identity</span>
            <div className="up-form-row">
              <div className="up-field">
                <label>
                  Full Name <span className="required">*</span>
                </label>
                <input
                  className={`up-input${errors.fullName ? " error" : ""}`}
                  value={form.fullName}
                  onChange={(e) => set("fullName", e.target.value)}
                  placeholder="Ahmed Al Balushi"
                />
                {errors.fullName && (
                  <span className="up-field-error">{errors.fullName}</span>
                )}
              </div>
              <div className="up-field">
                <label>Employee No</label>
                <input
                  className="up-input"
                  value={form.employeeNo}
                  onChange={(e) => set("employeeNo", e.target.value)}
                  placeholder="EMP-001"
                />
              </div>
            </div>
            <div className="up-form-row">
              <div className="up-field">
                <label>Mobile</label>
                <input
                  className="up-input"
                  value={form.mobile}
                  onChange={(e) => set("mobile", e.target.value)}
                  placeholder="+968 9XXX XXXX"
                />
              </div>
            </div>
          </div>

          {/* Contact */}
          <div className="up-form-section">
            <span className="up-form-section__label">Contact</span>
            <div className="up-form-row up-form-row--full">
              <div className="up-field">
                <label>
                  Email <span className="required">*</span>
                </label>
                <input
                  className={`up-input${errors.email ? " error" : ""}`}
                  type="email"
                  value={form.email}
                  onChange={(e) => set("email", e.target.value)}
                  placeholder="user@murasalone.com"
                />
                {errors.email && (
                  <span className="up-field-error">{errors.email}</span>
                )}
              </div>
            </div>
          </div>

          {/* Access */}
          <div className="up-form-section">
            <span className="up-form-section__label">
              Access & Organisation
            </span>
            <div className="up-form-row">
              <div className="up-field">
                <label>
                  Role <span className="required">*</span>
                </label>
                <select
                  className={`up-select${errors.roleId ? " error" : ""}`}
                  value={form.roleId}
                  onChange={(e) => set("roleId", e.target.value)}
                >
                  <option value="">Select role…</option>
                  {roles.map((r) => (
                    <option key={r.id} value={r.id}>
                      {r.name}
                    </option>
                  ))}
                </select>
                {errors.roleId && (
                  <span className="up-field-error">{errors.roleId}</span>
                )}
              </div>
              <div className="up-field">
                <label>
                  Department <span className="required">*</span>
                </label>
                <select
                  className={`up-select${errors.departmentId ? " error" : ""}`}
                  value={form.departmentId}
                  onChange={(e) => set("departmentId", e.target.value)}
                >
                  <option value="">Select department…</option>
                  {departments.map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.name}
                    </option>
                  ))}
                </select>
                {errors.departmentId && (
                  <span className="up-field-error">{errors.departmentId}</span>
                )}
              </div>
            </div>
          </div>

          {/* Password Setup Info Notice - Only shown when creating new user */}
          {!isEdit && (
            <div className="up-form-section">
              <div
                style={{
                  background: "#EFF6FF",
                  border: "1px solid #BFDBFE",
                  borderRadius: 8,
                  padding: "12px 16px",
                  display: "flex",
                  gap: 10,
                  alignItems: "flex-start",
                }}
              >
                <span style={{ color: "#3B82F6", marginTop: 1, flexShrink: 0 }}>
                  {Ico.Info}
                </span>
                <div
                  style={{ fontSize: 13, color: "#1E40AF", lineHeight: 1.5 }}
                >
                  <strong>Password Setup Email</strong>
                  <br />A password setup link will be automatically sent to the
                  user's email address. The link expires after 48 hours.
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="up-drawer__footer">
          <button
            className="up-btn up-btn--primary"
            style={{ flex: 1 }}
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? (
              <>
                <span className="up-spin">{Ico.Spinner}</span> Saving…
              </>
            ) : isEdit ? (
              "Save Changes"
            ) : (
              "Create User & Send Setup Email"
            )}
          </button>
          <button
            className="up-btn up-btn--secondary"
            onClick={onClose}
            disabled={saving}
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  );
}

// ─── View Profile Modal ───────────────────────────────────────────────────────
function UserProfileModal({ userId, onClose }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await getUserByIdApi(userId);
        setUser(res.data.user);
      } catch {
        onClose();
      } finally {
        setLoading(false);
      }
    })();
  }, [userId]);

  return (
    <>
      <div className="up-drawer-overlay" onClick={onClose} />
      <div className="up-drawer" style={{ maxWidth: 460 }}>
        <div className="up-drawer__header">
          <h3 className="up-drawer__title">User Profile</h3>
          <button className="up-drawer__close" onClick={onClose}>
            {Ico.Close}
          </button>
        </div>
        <div className="up-drawer__body">
          {loading ? (
            <div
              style={{ display: "flex", justifyContent: "center", padding: 40 }}
            >
              <span className="up-spin" style={{ fontSize: 24 }}>
                {Ico.Spinner}
              </span>
            </div>
          ) : user ? (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 16,
                  marginBottom: 24,
                }}
              >
                <div
                  className="up-user-cell__avatar"
                  style={{
                    background: avatarColor(user.fullName),
                    width: 56,
                    height: 56,
                    fontSize: 20,
                    flexShrink: 0,
                  }}
                >
                  {initials(user.fullName)}
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 17 }}>
                    {user.fullName}
                  </div>
                  <div style={{ fontSize: 13, color: "#6B7280" }}>
                    {user.email}
                  </div>
                  <span
                    className={`up-badge up-badge--${user.status?.toLowerCase()}`}
                    style={{ marginTop: 4, display: "inline-block" }}
                  >
                    {STATUS_LABEL[user.status] || user.status}
                  </span>
                </div>
              </div>
              {[
                ["Employee No", user.employeeNo],
                ["Mobile", user.mobile],
                ["Department", user.department?.name || user.department],
                ["Role", user.role?.name || user.role],
              ].map(([label, val]) => (
                <div
                  key={label}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px 0",
                    borderBottom: "1px solid #F3F4F6",
                  }}
                >
                  <span style={{ fontSize: 13, color: "#6B7280" }}>
                    {label}
                  </span>
                  <span style={{ fontSize: 13, fontWeight: 500 }}>
                    {val || "—"}
                  </span>
                </div>
              ))}
              {user.matrix && (
                <div
                  style={{
                    marginTop: 20,
                    background: "#F9FAFB",
                    borderRadius: 8,
                    padding: 14,
                  }}
                >
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#6B7280",
                      marginBottom: 10,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                    }}
                  >
                    Matrix Credentials
                  </div>
                  {[
                    ["Matrix User ID", user.matrix.userId],
                    ["Home Server", user.matrix.homeServer],
                    ["Device ID", user.matrix.deviceId],
                  ].map(([label, val]) => (
                    <div
                      key={label}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "6px 0",
                        fontSize: 12,
                      }}
                    >
                      <span style={{ color: "#6B7280" }}>{label}</span>
                      <span
                        style={{
                          fontFamily: "monospace",
                          color: "#374151",
                          wordBreak: "break-all",
                          maxWidth: 220,
                          textAlign: "right",
                        }}
                      >
                        {val}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </>
          ) : null}
        </div>
      </div>
    </>
  );
}

// ─── Main Component ───────────────────────────────────────────────────────────
const Users = () => {
  // ── Data state ────────────────────────────────────────────────────────────
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 20,
    total: 0,
  });
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [loadingMeta, setLoadingMeta] = useState(true);
  const [savingUser, setSavingUser] = useState(false);

  // ── UI state ──────────────────────────────────────────────────────────────
  const [search, setSearch] = useState("");
  const [searchDebounce, setSearchDebounce] = useState("");
  const [roleFilter, setRoleFilter] = useState("All Roles");
  const [deptFilter, setDeptFilter] = useState("All Departments");
  const [statusFilter, setStatusFilter] = useState("All Status");
  const [selected, setSelected] = useState([]);
  const [sortKey, setSortKey] = useState("fullName");
  const [sortDir, setSortDir] = useState("asc");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [drawer, setDrawer] = useState(null); // null | { mode: 'add'|'edit', user }
  const [viewUserId, setViewUserId] = useState(null);
  const [editLoading, setEditLoading] = useState(false);

  const { toasts, toast } = useToast();

  // ── Load roles + departments once ─────────────────────────────────────────
  useEffect(() => {
    (async () => {
      try {
        const [rolesRes, deptsRes] = await Promise.all([
          getRolesApi(),
          getDepartmentsApi(),
        ]);
        setRoles(rolesRes.data.roles || []);
        setDepartments(deptsRes.data.departments || []);
      } catch {
        toast.error("Failed to load roles / departments");
      } finally {
        setLoadingMeta(false);
      }
    })();
  }, []);

  // ── Debounce search ───────────────────────────────────────────────────────
  useEffect(() => {
    const t = setTimeout(() => setSearchDebounce(search.trim()), 400);
    return () => clearTimeout(t);
  }, [search]);

  // ── Fetch users ───────────────────────────────────────────────────────────
  const fetchUsers = useCallback(async () => {
    setLoadingUsers(true);
    try {
      let res;
      if (searchDebounce) {
        res = await searchUsersApi(searchDebounce);
        const list = res.data.users || res.data || [];
        setUsers(list);
        setPagination({ page: 1, limit: pageSize, total: list.length });
      } else {
        res = await getUsersApi(page, pageSize);
        setUsers(res.data.users || []);
        setPagination(
          res.data.pagination || { page, limit: pageSize, total: 0 },
        );
      }
    } catch {
      toast.error("Failed to load users");
    } finally {
      setLoadingUsers(false);
    }
  }, [page, pageSize, searchDebounce]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  // ── Derived stats ─────────────────────────────────────────────────────────
  const stats = useMemo(
    () => ({
      total: pagination.total || users.length,
      active: users.filter((u) => u.status === "ACTIVE").length,
      inactive: users.filter(
        (u) =>
          u.status === "DISABLED" ||
          u.status === "SUSPENDED" ||
          u.status === "LOCKED",
      ).length,
      pending: users.filter((u) => u.status === "PENDING").length,
    }),
    [users, pagination.total],
  );

  // ── Client-side filter + sort ─────────────────────────────────────────────
  const filtered = useMemo(() => {
    let list = [...users];
    if (roleFilter !== "All Roles")
      list = list.filter(
        (u) => u.role === roleFilter || u.role?.name === roleFilter,
      );
    if (deptFilter !== "All Departments")
      list = list.filter(
        (u) => u.department === deptFilter || u.department?.name === deptFilter,
      );
    if (statusFilter !== "All Status")
      list = list.filter((u) => u.status === statusFilter);
    list.sort((a, b) => {
      const aV = (a[sortKey] || "").toString().toLowerCase();
      const bV = (b[sortKey] || "").toString().toLowerCase();
      return sortDir === "asc" ? aV.localeCompare(bV) : bV.localeCompare(aV);
    });
    return list;
  }, [users, roleFilter, deptFilter, statusFilter, sortKey, sortDir]);

  const totalPages = Math.max(
    1,
    Math.ceil((searchDebounce ? filtered.length : pagination.total) / pageSize),
  );

  // ── Sort ──────────────────────────────────────────────────────────────────
  const handleSort = (key) => {
    if (sortKey === key) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    else {
      setSortKey(key);
      setSortDir("asc");
    }
  };

  // ── Selection ─────────────────────────────────────────────────────────────
  const allPageSelected =
    filtered.length > 0 && filtered.every((u) => selected.includes(u.id));
  const toggleAll = () =>
    setSelected(
      allPageSelected
        ? selected.filter((id) => !filtered.find((u) => u.id === id))
        : [...new Set([...selected, ...filtered.map((u) => u.id)])],
    );
  const toggleOne = (id) =>
    setSelected((s) =>
      s.includes(id) ? s.filter((x) => x !== id) : [...s, id],
    );

  // ── Drawer handlers ───────────────────────────────────────────────────────
  const openAdd = () => setDrawer({ mode: "add", user: null });

  // ── openEdit: fetch full user details first so department/role IDs are populated ──
  const openEdit = async (user) => {
    setEditLoading(true);
    try {
      const res = await getUserByIdApi(user.id);
      const fullUser = res.data.user;
      setDrawer({ mode: "edit", user: fullUser });
    } catch {
      toast.error("Failed to load user details");
    } finally {
      setEditLoading(false);
    }
  };

  const openView = (user) => setViewUserId(user.id);
  const closeDrawer = () => setDrawer(null);

  // ── Create or Update user ─────────────────────────────────────────────────
  const handleSave = async (payload, userId) => {
    setSavingUser(true);
    try {
      if (userId) {
        // PATCH /users/:id — edit existing user
        await updateUserApi(userId, payload);
        toast.success(`User "${payload.fullName}" updated successfully`);
      } else {
        // POST /users — create new user (password setup email sent automatically)
        await createUserApi(payload);
        toast.success(
          `User "${payload.fullName}" created successfully. A password setup email has been sent.`,
        );
      }
      closeDrawer();
      setPage(1);
      await fetchUsers();
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        (userId ? "Failed to update user" : "Failed to create user");
      toast.error(msg);
    } finally {
      setSavingUser(false);
    }
  };

  // ── Toggle status ─────────────────────────────────────────────────────────
  const handleToggleStatus = async (user) => {
    const newStatus = user.status === "ACTIVE" ? "DISABLED" : "ACTIVE";
    try {
      await updateUserStatusApi(user.id, { status: newStatus });
      toast.success(`${user.fullName} set to ${STATUS_LABEL[newStatus]}`);
      setUsers((prev) =>
        prev.map((u) => (u.id === user.id ? { ...u, status: newStatus } : u)),
      );
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to update status";
      toast.error(msg);
    }
  };

  const handleResetPw = async (user) => {
    try {
      await resetUserPasswordApi(user.id);
      toast.success(`Password setup email sent to ${user.email}`);
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to send reset email";
      toast.error(msg);
    }
  };

  const handleResetSessions = async (user) => {
    try {
      await resetUserSessionsApi(user.id);
      toast.success(`All sessions cleared for ${user.email}`);
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to reset sessions";
      toast.error(msg);
    }
  };
  const clearFilters = () => {
    setRoleFilter("All Roles");
    setDeptFilter("All Departments");
    setStatusFilter("All Status");
    setSearch("");
    setPage(1);
  };
  const hasFilters =
    roleFilter !== "All Roles" ||
    deptFilter !== "All Departments" ||
    statusFilter !== "All Status" ||
    search.trim();

  // ── Derived role / dept lists ─────────────────────────────────────────────
  const roleNames = useMemo(
    () => ["All Roles", ...roles.map((r) => r.name)],
    [roles],
  );
  const deptNames = useMemo(
    () => ["All Departments", ...departments.map((d) => d.name)],
    [departments],
  );

  // ── Sort header ───────────────────────────────────────────────────────────
  const SortTh = ({ col, label }) => (
    <th
      className={sortKey === col ? "sorted" : ""}
      onClick={() => handleSort(col)}
    >
      {label}
      <span
        className={`sort-icon${sortKey === col ? (sortDir === "asc" ? " asc" : " desc") : ""}`}
      >
        {Ico.SortUp}
      </span>
    </th>
  );

  return (
    <div className="users-page">
      <ToastStack toasts={toasts} />

      {/* Loading overlay while fetching user for edit */}
      {editLoading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 8888,
            background: "rgba(0,0,0,0.15)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 12,
              padding: "24px 32px",
              display: "flex",
              alignItems: "center",
              gap: 12,
              boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
            }}
          >
            <span
              className="up-spin"
              style={{ fontSize: 20, color: "#0062FE" }}
            >
              {Ico.Spinner}
            </span>
            <span style={{ fontSize: 14, color: "#374151", fontWeight: 500 }}>
              Loading user…
            </span>
          </div>
        </div>
      )}

      {/* ── Header ── */}
      <div className="up-header">
        <div className="up-header__left">
          <span className="up-header__label">User Management</span>
          <h1 className="up-header__title">Users</h1>
          <p className="up-header__subtitle">
            Manage application users, roles and access
          </p>
        </div>
        <div className="up-header__right">
          <button className="up-btn up-btn--secondary">
            {Ico.Download} Export
          </button>
          <button className="up-btn up-btn--primary" onClick={openAdd}>
            {Ico.Plus} Add User
          </button>
        </div>
      </div>

      {/* ── KPI Cards ── */}
      <div className="up-kpi-grid">
        {[
          {
            label: "Total Users",
            value: pagination.total || stats.total,
            color: "#0062FE",
            bg: "rgba(0,98,254,0.10)",
            icon: Ico.Users,
          },
          {
            label: "Active Users",
            value: stats.active,
            color: "#22C55E",
            bg: "rgba(34,197,94,0.10)",
            icon: Ico.Activity,
          },
          {
            label: "Inactive / Suspended",
            value: stats.inactive,
            color: "#EF4444",
            bg: "rgba(239,68,68,0.10)",
            icon: Ico.Shield,
          },
          {
            label: "Pending Setup",
            value: stats.pending,
            color: "#F97316",
            bg: "rgba(249,115,22,0.10)",
            icon: Ico.User,
          },
        ].map((k) => (
          <div key={k.label} className="up-kpi">
            <div
              className="up-kpi__icon"
              style={{ background: k.bg, color: k.color }}
            >
              {k.icon}
            </div>
            <div className="up-kpi__body">
              <div className="up-kpi__value">
                {loadingUsers ? "—" : k.value}
              </div>
              <div className="up-kpi__label">{k.label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* ── Toolbar ── */}
      <div className="up-toolbar">
        <div className="up-search-wrap">
          {Ico.Search}
          <input
            className="up-search"
            placeholder="Search by name, email, employee ID…"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1);
            }}
          />
          {loadingUsers && search && (
            <span className="up-spin" style={{ marginLeft: 8 }}>
              {Ico.Spinner}
            </span>
          )}
        </div>

        <select
          className="up-filter-select"
          value={roleFilter}
          onChange={(e) => {
            setRoleFilter(e.target.value);
            setPage(1);
          }}
        >
          {roleNames.map((r) => (
            <option key={r}>{r}</option>
          ))}
        </select>

        <select
          className="up-filter-select"
          value={deptFilter}
          onChange={(e) => {
            setDeptFilter(e.target.value);
            setPage(1);
          }}
        >
          {deptNames.map((d) => (
            <option key={d}>{d}</option>
          ))}
        </select>

        <select
          className="up-filter-select"
          style={{ minWidth: 120 }}
          value={statusFilter}
          onChange={(e) => {
            setStatusFilter(e.target.value);
            setPage(1);
          }}
        >
          {STATUSES.map((s) => (
            <option key={s} value={s}>
              {s === "All Status" ? s : STATUS_LABEL[s] || s}
            </option>
          ))}
        </select>

        {hasFilters && (
          <span className="up-filter-badge">
            {filtered.length} result{filtered.length !== 1 ? "s" : ""}
            <button onClick={clearFilters}>{Ico.XCircle}</button>
          </span>
        )}
      </div>

      {/* ── Table Card ── */}
      <div className="up-card">
        {selected.length > 0 && (
          <div className="up-selection-bar">
            <span>
              {selected.length} user{selected.length > 1 ? "s" : ""} selected
            </span>
            <button
              className="up-btn up-btn--ghost"
              style={{ fontSize: 13 }}
              onClick={() => alert("Bulk deactivate triggered")}
            >
              {Ico.Trash} Deactivate
            </button>
            <button
              className="up-btn up-btn--ghost"
              style={{ fontSize: 13 }}
              onClick={() => alert("Export triggered")}
            >
              {Ico.Download} Export
            </button>
            <button
              className="up-btn up-btn--ghost"
              style={{ fontSize: 13 }}
              onClick={() => setSelected([])}
            >
              {Ico.Close} Clear
            </button>
          </div>
        )}

        <div className="up-table-wrap">
          {loadingUsers ? (
            <div className="up-empty">
              <span
                className="up-spin"
                style={{ fontSize: 32, color: "#0062FE" }}
              >
                {Ico.Spinner}
              </span>
              <p style={{ marginTop: 12, color: "#6B7280" }}>Loading users…</p>
            </div>
          ) : filtered.length === 0 ? (
            <div className="up-empty">
              {Ico.Users}
              <h4>No users found</h4>
              <p>Try adjusting your search or filters.</p>
              {hasFilters && (
                <button
                  className="up-btn up-btn--secondary"
                  onClick={clearFilters}
                >
                  Clear Filters
                </button>
              )}
            </div>
          ) : (
            <table className="up-table">
              <thead>
                <tr>
                  <th style={{ width: 40 }}>
                    <input
                      type="checkbox"
                      checked={allPageSelected}
                      onChange={toggleAll}
                      style={{ accentColor: "#0062FE", cursor: "pointer" }}
                    />
                  </th>
                  <SortTh col="fullName" label="User" />
                  <SortTh col="employeeNo" label="Emp ID" />
                  <SortTh col="role" label="Role" />
                  <SortTh col="department" label="Department" />
                  <SortTh col="status" label="Status" />
                  <th style={{ width: 48 }} />
                </tr>
              </thead>
              <tbody>
                {filtered.map((u) => (
                  <tr
                    key={u.id}
                    className={selected.includes(u.id) ? "selected" : ""}
                  >
                    <td>
                      <input
                        type="checkbox"
                        checked={selected.includes(u.id)}
                        onChange={() => toggleOne(u.id)}
                        style={{ accentColor: "#0062FE", cursor: "pointer" }}
                      />
                    </td>
                    <td>
                      <div className="up-user-cell">
                        <div
                          className="up-user-cell__avatar"
                          style={{ background: avatarColor(u.fullName) }}
                        >
                          {initials(u.fullName)}
                        </div>
                        <div>
                          <div className="up-user-cell__name">{u.fullName}</div>
                          <div className="up-user-cell__username">
                            {u.email}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td
                      style={{
                        fontFamily: "monospace",
                        fontSize: 12.5,
                        color: "#6B7280",
                      }}
                    >
                      {u.employeeNo}
                    </td>
                    <td>
                      <span className="up-role-chip">
                        {u.role?.name || u.role}
                      </span>
                    </td>
                    <td>{u.department?.name || u.department}</td>
                    <td>
                      <span
                        className={`up-badge up-badge--${u.status?.toLowerCase()}`}
                      >
                        {STATUS_LABEL[u.status] || u.status}
                      </span>
                    </td>
                    <td>
                      <RowMenu
                        user={u}
                        onView={openView}
                        onEdit={openEdit}
                        onToggleStatus={handleToggleStatus}
                        onResetPw={handleResetPw}
                        onResetSessions={handleResetSessions}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* ── Pagination ── */}
        <div className="up-pagination">
          <div className="up-pagination__info">
            {!searchDebounce && (
              <>
                Showing {Math.min((page - 1) * pageSize + 1, pagination.total)}–
                {Math.min(page * pageSize, pagination.total)} of{" "}
                {pagination.total} users &nbsp;·&nbsp;
              </>
            )}
            <select
              value={pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
                setPage(1);
              }}
            >
              {PAGE_SIZE_OPTIONS.map((n) => (
                <option key={n}>{n}</option>
              ))}
            </select>{" "}
            per page
          </div>
          {!searchDebounce && (
            <div className="up-pagination__controls">
              <button
                className="up-pagination__page"
                disabled={page === 1}
                onClick={() => setPage(1)}
              >
                &laquo;
              </button>
              <button
                className="up-pagination__page"
                disabled={page === 1}
                onClick={() => setPage((p) => p - 1)}
              >
                {Ico.ChevronL}
              </button>
              {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                const p = Math.max(1, Math.min(totalPages - 4, page - 2)) + i;
                return (
                  <button
                    key={p}
                    className={`up-pagination__page${page === p ? " active" : ""}`}
                    onClick={() => setPage(p)}
                  >
                    {p}
                  </button>
                );
              })}
              <button
                className="up-pagination__page"
                disabled={page === totalPages}
                onClick={() => setPage((p) => p + 1)}
              >
                {Ico.ChevronR}
              </button>
              <button
                className="up-pagination__page"
                disabled={page === totalPages}
                onClick={() => setPage(totalPages)}
              >
                &raquo;
              </button>
            </div>
          )}
        </div>
      </div>

      {/* ── Add / Edit Drawer ── */}
      {drawer && (
        <UserDrawer
          user={drawer.user}
          roles={roles}
          departments={departments}
          onClose={closeDrawer}
          onSave={handleSave}
          saving={savingUser}
        />
      )}

      {/* ── View Profile Modal ── */}
      {viewUserId && (
        <UserProfileModal
          userId={viewUserId}
          onClose={() => setViewUserId(null)}
        />
      )}
    </div>
  );
};

export default Users;
